"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METADATA_FIELD_NAMES = void 0;
exports.METADATA_FIELD_NAMES = {
    SOURCE_DATE: 'SRC_DATE2',
    SOURCE_PROVIDER: 'NICE_DESC',
    SOURCE_NAME: 'SRC_DESC',
    RESOLUTION: 'SAMP_RES',
    ACCURACY: 'SRC_ACC',
};
//# sourceMappingURL=config.js.map